import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const CustomerSyncLogList = () => {
  const fetchUrl = `${API_DOMAIN}${API_ROUTES.customerSyncLog}`;

  const columns = [
    { label: 'Sync Event Type', value: 'sync_event_type' },
    { label: 'Success', value: item => item.success ? 'Yes' : 'No' },
    { label: 'Processed At', value: (item) => fmtDateTime(item.processed_at) },
    { label: 'Error Message', value: 'error_message' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/sync-log/details/${id}`;
  };

  return (
    <div>
      <h1>Customer Sync Logs</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default CustomerSyncLogList;
